namespace TabAurous.Common {
     
    @Serenity.Decorators.registerEditor()
    export class AllItemTypeEditor extends Serenity.RadioButtonEditor {
        constructor(hidden: JQuery) {
            super(hidden, null);
            this.addRadio("101", "Jewellery");
            this.addRadio("104", "Metal");
            this.addRadio("105", "Stone");
        }
    }
    @Serenity.Decorators.registerEditor()
    export class JewelleryTypeEditor extends Serenity.RadioButtonEditor {
        constructor(hidden: JQuery) {
            super(hidden, null);
            this.addRadio("101", "Jewellery"); 
        }
    }
    @Serenity.Decorators.registerEditor()
    export class MetalTypeEditor extends Serenity.RadioButtonEditor {
        constructor(hidden: JQuery) {
            super(hidden, null); 
            this.addRadio("104", "Metal"); 
        }
    }
    @Serenity.Decorators.registerEditor()
    export class StoneTypeEditor extends Serenity.RadioButtonEditor {
        constructor(hidden: JQuery) {
            super(hidden, null); 
            this.addRadio("105", "Stone");
        }
    }
    @Serenity.Decorators.registerEditor()
    export class JewelleryandMetalTypeEditor extends Serenity.RadioButtonEditor {
        constructor(hidden: JQuery) {
            super(hidden, null);
            this.addRadio("101", "Jewellery");
            this.addRadio("104", "Metal");
        }
    }
    @Serenity.Decorators.registerEditor()
    export class JewelleryandStoneTypeEditor extends Serenity.RadioButtonEditor {
        constructor(hidden: JQuery) {
            super(hidden, null);
            this.addRadio("101", "Jewellery");
            this.addRadio("105", "Stone");
        }
    }
    @Serenity.Decorators.registerEditor()
    export class MetalandStoneEditor extends Serenity.RadioButtonEditor {
        constructor(hidden: JQuery) {
            super(hidden, null);
            this.addRadio("104", "Metal");
            this.addRadio("105", "Stone");
        }
    }
}